import React from "react";
import { ReactComponent as IconPdf } from "../../build/images/iconpdf.svg";
import { ReactComponent as IconExl } from "../../build/images/iconexl.svg";
import { ReactComponent as IconZip } from "../../build/images/iconzip.svg";
import { ReactComponent as IconTxt } from "../../build/images/icontxt.svg";
import { ReactComponent as IconPpt } from "../../build/images/iconppt.svg";
import { ReactComponent as IconDoc } from "../../build/images/icondoc.svg";
import { ReactComponent as IconXlsx } from "../../build/images/iconxlsx.svg";
import { ReactComponent as IconJpg } from "../../build/images/iconjpeg.svg";
import { ReactComponent as IconPng } from "../../build/images/iconpng.svg";
import { ReactComponent as IconMp4 } from "../../build/images/iconmp4.svg";
import { Tooltippy } from "../../actions/Tippy";
import { DownloadFileByURL } from "../../actions";
import { useDispatch } from "react-redux";

const CarrousselAttach = ({attach}) => {
    const dispatch = useDispatch();


    const downloadFile = () => {
        dispatch(DownloadFileByURL(attach,attach.path.split('/').pop()))
    }

    return (
        <div className="attendance__mail-container__attachment">
                <div className="attendance__mail-container__attachment-box">
                    {
                        (() => {
                            if(attach.path.split(".")[1] === 'pdf'){
                                return <IconPdf />
                            }else if(attach.path.split(".")[1] === 'exl'){
                                return <IconExl />
                            }else if(attach.path.split(".")[1] === 'zip'){
                                return <IconZip />
                            }else if(attach.path.split(".")[1] === 'ppt'){
                                return <IconPpt />
                            }else if(attach.path.split(".")[1] === 'txt'){
                                return <IconTxt />
                            }else if(attach.path.split(".")[1] === 'xlsx'){
                                return <IconXlsx />
                            }else if(attach.path.split(".")[1] === 'jpg'){
                                return <IconJpg />
                            }else if(attach.path.split(".")[1] === 'jpeg'){
                                return <IconJpg />
                            }else if(attach.path.split(".")[1] === 'png'){
                                return <IconPng />
                            }else if(attach.path.split(".")[1] === 'mp4'){
                                return <IconMp4 />
                            }else{
                                return <IconDoc />
                            }
                        })()
                    }
                    <Tooltippy content={attach.path.split('/').pop()}>
                        <span>{attach.path.split('/').pop()}</span>
                    </Tooltippy>
                </div>
                <div className="column-actions">
                    <button
                        type="button"
                        className="btn action with-icon with-dropdown fix-center tippy-popover"
                        id="chat-action-download"
                        data-tooltip="Baixar"
                        style={{border: 0, minHeight: '14px'}}
                        onClick={() => downloadFile()}
                    >
                        <i className="material-icons">download</i>
                    </button>
                </div>
        </div>
    );
};

export default CarrousselAttach;
